var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Tracking"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tracking",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_person_pin_circle_24px",
    className: "cls-2",
    d: "M11.117,2A6.124,6.124,0,0,0,5,8.117c0,4.588,6.117,11.361,6.117,11.361s6.117-6.773,6.117-11.361A6.124,6.124,0,0,0,11.117,2Zm0,1.748A1.748,1.748,0,1,1,9.369,5.5,1.753,1.753,0,0,1,11.117,3.748Zm0,8.739a4.18,4.18,0,0,1-3.5-1.879c.017-1.154,2.333-1.791,3.5-1.791s3.478.638,3.5,1.791A4.18,4.18,0,0,1,11.117,12.487Z",
    transform: "translate(-5 -2)",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.cdaab41a20c1c5122ec71e5da8ea9d74.svg";
export { ForwardRef as ReactComponent };